import React, { useRef, useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../../shadcn/components/ui/card";
import CheckIcon from "../../../icons/CheckIcon";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../shadcn/components/ui/tabs";

interface StaticPageData {
  title?: string;
  children?: React.ReactNode;
}

interface props {
  textContentData?: StaticPageData[];
  children?: React.ReactNode;
  className?: string;
}

export function TablistStaticPages({
  textContentData,
  children,
  className,
}: props) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateScrollPosition = () => {
      const scrollPercentage =
        2.3 *
        (scrollContainer.scrollLeft /
          (scrollContainer.scrollWidth - scrollContainer.clientWidth)) *
        100;
      scrollContainer.style.setProperty(
        "--scroll-position",
        `${scrollPercentage}%`
      );
    };

    scrollContainer.addEventListener("scroll", updateScrollPosition);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollPosition);
  }, []);
  return (
    <Tabs
      defaultValue={`${textContentData && textContentData[0]?.title}`}
      className={`w-full px-customPaddingMobile lg:px-customPadding ${className}`}
    >
      <div className="overflow-auto scrollbar-hide">
        <TabsList className=" lg:w-[714px]  gap-[21px] lg:gap-[50px] bg-white  font-openSans font-normal text-web-body-md lg:text-web-body-lg leading-4 text-[#A8A8A8]">
          {textContentData?.map((item: any, index) => (
            <TabsTrigger key={`item-${index}`} value={item?.title}>
              {item?.title}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {textContentData?.map((item: any, index) => (
        <TabsContent
          key={`item-${index}`}
          className="mt-6 lg:mt-9"
          value={item?.title}
        >
          <Card className="border-none shadow-none relative">
            <div
              ref={scrollContainerRef}
              className="flex overflow-x-auto pb-1 lg:grid lg:grid-cols-3 gap-6 font-openSans font-normal text-mobile-body-sm leading-5 text-brand-textGrey"
            >
              {item?.children}
            </div>
          </Card>
        </TabsContent>
      ))}
    </Tabs>
  );
}
